import React, { useState } from "react";
import {
  GetCustomerContractEventLog,
  useDeleteCustomerContractEventMutation,
  useUpdateCustomerContractEventMutation,
  EventLog_EventFragment
} from "@graphql";
import { Event } from "@containers/EventLog/Event/Event";
import { InlineEditor } from "@common/InlineEditor/InlineEditor";
import { StyledHtml } from "@common/StyledHtml";
import { CustomerContractEventFloatingMenu } from "../CustomerContractFloatingMenu/CustomerContractEventFloatingMenu";
import { store } from "@store";
import locale from "@bonliva-crm/locale";
import { Link } from "@material-ui/core";
import { OpenInNew } from "@material-ui/icons";

type Props = {
  event: EventLog_EventFragment;
  customerContractId: string;
};
export function CustomerContractEvent(props: Props) {
  const { event, customerContractId } = props;
  const [isEditing, setIsEditing] = useState(false);
  const [submit] = useUpdateCustomerContractEventMutation();
  const [deleteEvent] = useDeleteCustomerContractEventMutation();

  const handleRes = (promise, successMsg: string, cb?: () => void) => {
    return promise
      .then(({ errors }) => {
        if (errors) {
          store().snackbars.error(errors.toString());
        }
        store().snackbars.success(successMsg);
      })
      .catch((e) => store().snackbars.error(e))
      .finally(cb && cb());
  };

  const handleDelete = () => {
    return handleRes(
      deleteEvent({
        variables: {
          customerContractId,
          eventId: event._id
        },
        refetchQueries: [GetCustomerContractEventLog.OperationName]
      }),
      locale.Deleted
    );
  };

  const handlePin = () => {
    return handleRes(
      submit({
        variables: {
          customerContractId,
          eventLog: {
            _id: event._id,
            description: event.Description,
            sticky: !event.Sticky
          }
        },
        refetchQueries: [GetCustomerContractEventLog.OperationName]
      }),
      locale.Sticky
    );
  };

  const handleEdit = (data) => {
    return handleRes(
      submit({
        variables: {
          customerContractId,
          eventLog: {
            _id: event._id,
            sticky: event.Sticky,
            description: data
          }
        },
        refetchQueries: [GetCustomerContractEventLog.OperationName]
      }),
      locale.Updated,
      () => setIsEditing(false)
    );
  };

  const menu = (
    <CustomerContractEventFloatingMenu
      event={event}
      onEdit={() => setIsEditing(true)}
      onDelete={handleDelete}
      onPin={handlePin}
    />
  );
  return (
    <Event item={event} floatingMenu={menu}>
      <>
        <InlineEditor
          readOnlyRenderer={() => (
            <>
              <StyledHtml styleProps={{ display: "inline-block" }}>
                {event.DescriptionHtml}
              </StyledHtml>
              {event.Links &&
                event.Links.map((url, i) => (
                  <Link
                    key={i}
                    href={url}
                    target="_blank"
                    style={{
                      display: "inline-block",
                      verticalAlign: "bottom",
                      padding: "0 4px",
                      lineHeight: 1
                    }}
                  >
                    <OpenInNew />
                  </Link>
                ))}
            </>
          )}
          initialValue={event.Description}
          onSubmit={handleEdit}
          isEditing={isEditing}
          onCancel={() => setIsEditing(false)}
        />
      </>
    </Event>
  );
}
